/**
 * Validates a string to check if it matches one of two specific formats:
 *
 * 1. A 14-character alphanumeric string with no separators or special characters.
 *    Example: "U1AtTi1CLTEtMQ"
 *
 * 2. A hyphen-separated string with exactly 5 sections.
 *    Each section must contain 1 to 2 alphanumeric characters.
 *    Example: "SP-N-B-1-1"
 *
 * @param {string} input - The input string to validate.
 * @returns {boolean} - Returns `true` if the input matches one of the two valid formats, otherwise `false`.
 */
export const isValidCodeOrSerial = (input: string): boolean => {
	const regex = /^(?:[a-z\d]{14,50}|[a-z\d]{1,8}(?:-[a-z\d]{1,8}){4})$/i;
	return regex.test(input);
};
